<template>
  <div>

    <Timeline :steps="timelineSteps"></Timeline>

    <h1 v-if="isAddonBooking">Snart dags för din semester!</h1>
    <h1 v-else>Snart är din semester bokad!</h1>
    <p class="ingress">Gör den mer bekväm med våra tillval:</p>

    <!--<div class="center">
      <div class="space center">
        <button class="no-hover" @click="openModal(['AccomodationSkipass'])" :disabled="!validatedSkipasses()" v-if="!cartSkipassObject.confirmed">Lägg till liftkort</button>
        <button class="small green" @click="openModal(['AccomodationSkipass'])" v-if="cartSkipassObject.confirmed">{{noOfSkipasses()}} st liftkort valda</button>
        <button class="small trash border" @click="openModal(['AccomodationSkipass'])" v-if="cartSkipassObject.confirmed"><icon name="edit" :scale="1.7" /></button>
      </div>
    </div>-->

    <div class="bg-color-faded">

    <div class="addons">

      <h2 class="center">BOKA TILLVAL TILL ERT BOENDE</h2>

      <p style="text-align:center;margin-bottom:1em;" v-if="true">En barnsäng och barnstol ingår alltid i våra boenden.</p>

      <div class="list">

        <div :title="($store.state.isDebugging) ? addon.lid : ''" :class="'addon center ' + (addon.added ? 'selected' : '') + ' ' + (addon.auto === 'T' ? 'auto' : '')" v-for="addon in addons" @click.stop="chooseArticle(addon)" v-if="!addon.hide_for_guest">
          <div class="addon-image default-image" @click.stop="infoPopup(addon)" :style="addon.image ? 'background-image:url(https://static.booking.branasgruppen.se/static/svg/addons/' + addon.image + ');' : 'background-size: cover;'">
            <icon name="info-blue" :scale="0.9" />
          </div>
          <div class="addon-content">
            <b>{{addon.arttext}}</b>
            <!--{{addon.type_input}}-->
            <p><span style="font-weight:700;">{{((
                (addon.rut && ($store.state.cart.ssn || !addon.added))
              ) ? (parseFloat(addon.curraprice) * 0.5) : addon.curraprice) | currency}}</span><span v-if="!addon.rut && !addon.single_count && addon.max_qty > 1">/st</span> <span v-if="(
                (addon.rut && ($store.state.cart.ssn || !addon.added))
              )" class="with-rut">med RUT-avdrag</span></p>

            <div style="text-align:left;" class="input-wrapper" v-if="addon.auto !== 'T'">
              <!-- Select count -->
              <span class="quantity" v-if="!addon.added && addon.max_qty > 1 && !addon.single_count" @click.stop="">
                <input type="number" :min="addon.min_qty" :max="addon.max_qty" v-model="addon.qtySelected" /> <span style="font-weight:bold;">st</span>
              </span>
              <!-- Picked count -->
              <button :class="'small ' + (addon.added ? 'green' : '') + ''" @click.stop="removeArticle(addon)" v-if="addon.added">
                <span v-if="addon.max_qty > 1 && !addon.single_count">
                  {{addon.qtySelected}}st valda
                </span>
                <span v-else>
                  Vald
                </span>
              </button>
              <!-- Trash -->
              <button :class="'small trash border'" @click.stop="removeArticle(addon)" v-if="addon.added"><icon name="trash" :scale="1.3" /></button>
              <!-- Pick button -->
              <button :class="{small: true, disabled: !addon.qtySelected}" @click.stop="chooseArticle(addon)" v-if="!addon.added">Välj</button>
            </div>

            <div style="text-align:left;" class="input-wrapper" v-if="addon.auto === 'T'">
              <button :class="'small ' + 'green' + ' non-clickable'">
                <span>
                  {{ addon.autoText || 'Obligatoriskt' }}
                </span>
              </button>
            </div>

          </div>
        </div>

      </div>

    </div>

    <div class="addons grocery-bags" v-if="groceryBags.length">

      <h2 class="center">GÖR DIN RESA ÄNNU MER BEKVÄM</h2>

      <div class="list">

        <div :title="($store.state.isDebugging) ? addon.lid : ''" :class="'addon center ' + (addon.added ? 'selected' : '')" v-for="addon in groceryBags" @click.stop="toggleArticle(addon)">
          <div class="addon-image default-image" @click.stop="infoPopup(addon)" :style="addon.image ? 'background-image:url(https://static.booking.branasgruppen.se/static/svg/addons/' + addon.image + ');' : 'background-size: cover;'">
          </div>
          <div class="addon-content">
            <h2 @click.stop="infoPopup(addon)">{{addon.arttext}}&nbsp;&nbsp;<icon name="info-blue" :scale="1" /></h2>
            <!--{{addon.type_input}}-->
            <p><span style="font-weight:300;font-size: 11px;">För 4 personer</span></p>
            <p><span style="font-weight:700;font-size:16px;">{{addon.curraprice | currency}}</span>/st</span></p>

            <div style="text-align:center;" class="input-wrapper">
              <!-- Select count -->
              <span class="quantity" v-if="!addon.added && addon.max_qty > 1 && !addon.single_count" @click.stop="">
                <input type="number" :min="addon.min_qty" :max="addon.max_qty" v-model="addon.qtySelected" /> <span style="font-weight:bold;">st</span>
              </span>
              <!-- Picked count -->
              <button :class="'small ' + (addon.added ? 'green' : '') + ''" @click.stop="removeArticle(addon)" v-if="addon.added">
                <span>
                  Vald
                </span>
              </button>
              <!-- Trash -->
              <button :class="'small trash border'" @click.stop="removeArticle(addon)" v-if="addon.added"><icon name="trash" :scale="1.3" /></button>
              <!-- Pick button -->
              <button :class="{small: true, disabled: !addon.qtySelected}" @click.stop="chooseArticle(addon)" v-if="!addon.added">Välj</button>
            </div>

          </div>
        </div>

      </div>

    </div>

    <div class="center spacing" v-if="lateArrivalObject">
      <div class="late-arrival">
        <div class="inner">
          <p>
            <b>
              Sen ankomst
              <span style="position:relative;top:-2px;left:5px;cursor:pointer;display:inline-block;" @click="openLateCheckinInfo()">
                <icon name="info-blue" :scale="1" />
              </span>
            </b>
            <span>Sen incheckning, efter kl {{ lateArrivalTime }}.</span>
          </p>

          <p class="checkboxes">
            <Checkbox @click="unmarkLateError(); toggleLate({value: true});" :class="{error: markLate}" label="JA" label-position="after" :value="true" :valuebinder.sync="lateArrival"></Checkbox>
            <Checkbox @click="unmarkLateError(); toggleLate({value: false});" :class="{error: markLate}" label="NEJ" label-position="after" :value="false" :valuebinder.sync="lateArrival"></Checkbox>
          </p>
        </div>
      </div>
    </div>

    <div class="cancellation-insurance" v-if="isSummerSeason">
      <h3 v-if="SITE_CONFIG.accomodations.date_picker_help.summer_title"><icon name="info-blue" :scale="1" /> {{ SITE_CONFIG.accomodations.date_picker_help.summer_title }}</h3>
      <p v-if="SITE_CONFIG.accomodations.date_picker_help.summer_info2">
        <span v-html="SITE_CONFIG.accomodations.date_picker_help.summer_info2"></span>
      </p>

      <p v-if="SITE_CONFIG.accomodations.date_picker_help.summer_info3">
        <span v-html="SITE_CONFIG.accomodations.date_picker_help.summer_info3"></span>
      </p>
    </div>

    <div class="cancellation-insurance" v-if="cancellationInsuranceEnabled && cancellationInsuranceObject">
      <p class="required-notice"><span>*</span> Obligatoriska fält</p>
      <h3><icon name="avbestallning" :scale="2" /> Avbeställningskydd <em>{{cancellationInsuranceObject.curraprice | currency}}</em></h3>
      <p>Branäsgruppen erbjuder ett av branschens mest generösa om- och avbokningsskydd. Det innebär att om du har köpt vårt om- och avbeställningsskydd kan du fritt omboka eller avboka fram tills dess att det är 20 dagar kvar till ankomst. Du behöver inget skäl eller intyg. När det är 20 dagar kvar eller mindre till ankomst kan du med ett giltigt skäl och ett intyg om- eller avboka mot en expeditionsavgift på 200 kr. Läs mer i våra bokningsregler. </p>
      <p v-html="cancellationInsuranceObject.text"></p>

      <p>
        <Checkbox @click="unmarkInsuranceError()" :class="{error: markInsurance, 'non-clickable': cancellationInsuranceObject.free}" label="JA" label-position="after" :value="true" :valuebinder.sync="cancellationInsurance"></Checkbox>
        <Checkbox @click="unmarkInsuranceError()" :class="{error: markInsurance, disabled: cancellationInsuranceObject.free}" label="NEJ" label-position="after" :value="false" :valuebinder.sync="cancellationInsurance"></Checkbox>
        <div style="clear:both;"></div>
      </p>
    </div>

    <div class="center" style="margin-top:2em;padding-bottom:2em;">
      <button @click="next()" :class="{disabled: !validated()}">Nästa</button>
    </div>

    </div>

  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import Timeline from '@/components/components/Timeline';
import SwitchButton from '@/components/components/SwitchButton';
import Dropdown from '@/components/components/Dropdown';
import Checkbox from '@/components/components/Checkbox';
import API from '@/classes/API';

import accomodationTimelineSteps from '@/mixins/accomodationTimelineSteps';
import accomodationIndex from '@/mixins/accomodationIndex';

export default {
  name: 'addonspage',
  components: {
    Modal,
    Timeline,
    SwitchButton,
    Checkbox,
    Dropdown,
  },
  mixins: [accomodationTimelineSteps, accomodationIndex],
  data() {
    return {
      cartAccomodationObject: {},
      cartSkipassObject: {},
      showingSkipassModal: false,
      adultDays: 0,
      youthDays: 0,
      childrenDays: 0,
      adults: 0,
      youths: 0,
      children: 0,
      addons: [],
      adultPricelistPrice: 0,
      youthPricelistPrice: 0,
      cancellationInsurance: null,
      markInsurance: false,
      markLate: false,
      cancellationInsuranceObject: {},
      lateArrivalObject: {},
      lateArrival: null,
      cancellationInsuranceEnabled: false,
      groceryBags: [],
    };
  },
  mounted() {
    if (this.$route.name === 'addons') {
      if (!this.cart.accomodations.length) {
        this.$router.replace({ name: 'accomodation list' });
        return;
      }

      if (!this.cart.accomodations[0].confirmed) {
        this.$router.replace({ name: 'confirm-accomodation' });
        return;
      }
    }

    this.$nextTick(() => {
      let currentSkipassIndex = -1;
      const $this = this;
      this.cart.skipasses.forEach((skipass, index) => {
        if (skipass.type === 'SKIPASS-ACCO' && skipass.belongsTo === $this.accomodationIndex && skipass.confirmed) {
          currentSkipassIndex = index;
        }
      });

      if (currentSkipassIndex === -1 && this.SITE_CONFIG.accomodations.skipass_campaign_active && $this.$route.name !== 'addons extra') {
        this.openModal(['AccomodationSkipass', {}]);
      }
    });

    const currentAccomodationIndex = this.accomodationIndex;

    if (!this.isAddonBooking) {
      this.cartAccomodationObject = this.cart.accomodations[currentAccomodationIndex];
    } else {
      this.cartAccomodationObject = {
        poolLid: this.$route.query.pool,
        unitLid: this.$route.query.unit,
        period: {
          date_arrival: this.$route.query.arrival,
          date_departure: this.$route.query.departure,
        },
        adults: parseInt(this.$route.query.adults, 10),
        youths: parseInt(this.$route.query.youths, 10),
        children: parseInt(this.$route.query.children, 10),
        seniors: parseInt(this.$route.query.seniors, 10),
      };
    }

    const currentSkipassIndex = this.cart.currentSkipassIndex;

    if (this.$route.name === 'addons') {
      this.cartSkipassObject = this.cart.skipasses[currentSkipassIndex];
    } else if (this.$route.name === 'addons extra') {
      this.cartSkipassObject = {
        adults: parseInt(this.$route.query.adults, 10),
        youths: parseInt(this.$route.query.youths, 10),
        children: parseInt(this.$route.query.children, 10),
      };
    }

    if (this.isAddonBooking) {
      this.cancellationInsuranceEnabled = false;
    } else {
      this.cancellationInsuranceEnabled = true;
    }

    this.getAddons();
  },
  computed: {
    ...mapGetters([
      'cart',
    ]),
    isAddonBooking() {
      return this.$route.name === 'addons extra';
    },
    isSummerSeason() {
      let month = 12;
      try {
        month = moment(this.cartAccomodationObject.period.date_arrival);
      } catch (e) {
        return false;
      }

      if (month.get('month') >= 4 && month.get('month') <= 10) {
        return true;
      }

      return false;
    },
    lateArrivalTime() {
      if (this.SITE_CONFIG.site === 'kungsberget') {
        return '18:00';
      }

      return '17:00';
    },
  },
  methods: {
    validated() {
      let cancellation = (this.cancellationInsurance === true
        || this.cancellationInsurance === false);
      let late = (this.lateArrival === true || this.lateArrival === false);

      if (this.isAddonBooking) {
        cancellation = true;
      }

      if (!this.lateArrivalObject) {
        late = true;
      }

      if (!this.cancellationInsuranceEnabled || !this.cancellationInsuranceObject) {
        cancellation = true;
      }

      return cancellation && late;
    },
    icon(icon) {
      const icons = {
        1022: 'linneset', // Sänglinne, påslakan,underlakan, handduk,badlakan
        1031: 'stadning', // Slutstäd. Exkl. disk och soptömning.
        1027: 'barnsang', // Barnsäng
        1025: 'barnstol', // Barnstol
        1156: 'baddning', // Bäddning
      };

      return icons[icon] ? icons[icon] : 'none';
    },
    async getAddons() {
      let url = `/units/${this.cartAccomodationObject.poolLid}/${this.cartAccomodationObject.unitLid}/addons/${this.cartAccomodationObject.period.date_arrival}/${this.cartAccomodationObject.period.date_departure}/${this.cartAccomodationObject.adults}/${this.cartAccomodationObject.youths}/${this.cartAccomodationObject.children}/${this.cartAccomodationObject.seniors}`;

      if (this.$store.state.cart.addToOrder && this.$store.state.cart.addToOrder.numeric) {
        url = `${url}?order=${this.$store.state.cart.addToOrder.numeric}&order-line-group=${this.$store.state.cart.addToOrder.accomodationGroup}`;
      }
      const { data, meta_skipasses,
        cancellationInsurance, lateArrival, groceryBags } = await API.get(url);

      const $this = this;
      this.addons = data.map((addon) => {
        // let start = parseInt(addon.min_qty, 10);
        // const end = parseInt(addon.max_qty, 10);
        const a = addon;
        a.qtySelected = 1;
        /* a.options = [];
        while (start <= end) {
          if (!start) {
            a.options.push({ title: 'ANTAL', value: 0 });
          } else {
            a.options.push({ title: `${start} st`, value: start });
          }
          start += 1;
        } */

        const index = this.cart.addons.findIndex(localAddon =>
          localAddon.lid === a.lid
          && localAddon.belongsTo === $this.accomodationIndex);

        a.added = (index !== -1);

        if (a.added) {
          a.qtySelected = this.cart.addons[index].quantity;
        }

        if (a.auto === 'T' && !this.isAddonBooking) {
          if (!a.added) {
            this.chooseArticle(addon, true);
          }
        }

        if (!addon.added && addon.max_qty > 1 && !addon.single_count) {
          a.qtySelected = this.cartSkipassObject.adults +
            this.cartSkipassObject.youths +
            this.cartSkipassObject.children +
            (this.cartSkipassObject.seniors || 0);

          if (a.default_qty) {
            a.qtySelected = a.default_qty;
          }
        }

        if (!addon.added && addon.included) {
          a.qtySelected = 0;
        }

        return a;
      });

      this.groceryBags = groceryBags.map((addon) => {
        const a = addon;
        a.qtySelected = 1;

        const index = this.cart.addons.findIndex(localAddon =>
          localAddon.lid === a.lid
          && localAddon.belongsTo === $this.accomodationIndex);

        a.added = (index !== -1);

        return a;
      });

      this.lateArrivalObject = lateArrival;
      this.cancellationInsuranceObject = cancellationInsurance;

      // Cancellation check
      const cancelIndex = this.cart.addons.findIndex(localAddon =>
        localAddon.lid === $this.cancellationInsuranceObject.lid
        && localAddon.belongsTo === $this.accomodationIndex);

      if (cancelIndex !== -1) {
        this.cancellationInsurance = true;
      }

      if (!this.isAddonBooking && this.cancellationInsuranceObject
        && this.cancellationInsuranceObject.free) {
        this.cancellationInsurance = true;
        this.unmarkInsuranceError();
      }

      // Late arrival check
      const arrivalIndex = this.cart.addons.findIndex(localAddon =>
        localAddon.lid === $this.lateArrivalObject.lid
        && localAddon.belongsTo === $this.accomodationIndex);

      if (arrivalIndex !== -1) {
        this.lateArrival = true;
      }

      if (meta_skipasses.adult.separate_days) {
        this.adultPricelistPrice = Math.round(
          parseFloat(meta_skipasses.adult.separate_days.aprice, 10),
        );
      } else if (meta_skipasses.adult.week) {
        this.adultPricelistPrice = Math.round(
          parseFloat(meta_skipasses.adult.week.aprice, 10),
        );
      } else {
        this.adultPricelistPrice = 0;
      }

      if (meta_skipasses.youth.separate_days) {
        this.youthPricelistPrice = Math.round(
          parseFloat(meta_skipasses.youth.separate_days.aprice, 10),
        );
      } else if (meta_skipasses.youth.week) {
        this.youthPricelistPrice = Math.round(
          parseFloat(meta_skipasses.youth.week.aprice, 10),
        );
      } else {
        this.youthPricelistPrice = 0;
      }

      this.cartSkipassObject.adultsPrice = this.adultPricelistPrice;
      this.cartSkipassObject.youthsPrice = this.youthPricelistPrice;
    },
    ...mapMutations([
      'confirmSkipasses',
      'unconfirmSkipasses',
      'addAddon',
      'removeAddon',
      'addSkipasses',
      'openModal',
      'closeModal',
    ]),
    doChooseArticle(addon) {
      addon.added = true; // eslint-disable-line no-param-reassign
      addon.belongsTo = this.accomodationIndex; // eslint-disable-line no-param-reassign
      addon.locked = addon.auto === 'T'; // eslint-disable-line no-param-reassign

      if (this.isAddonBooking) {
        addon.belongsTo = -2; // eslint-disable-line no-param-reassign
      }

      this.addAddon(addon);
    },
    chooseArticle(addon, force) {
      const $this = this;

      if (force) {
        $this.doChooseArticle(addon);
      }

      if (addon.qtySelected) {
        if (addon.rut) {
          this.openModal(['RutModal', {
            click: () => {
              $this.doChooseArticle(addon);
            },
            cancel: () => {
              $this.doChooseArticle(addon);
            },
          }]);
        } else if (addon.included) {
          this.openModal(['IncludedInPriceModal', {
            addon,
            click: () => {
              $this.doChooseArticle(addon);
            },
          }]);
        } else {
          this.doChooseArticle(addon);
        }
      } else {
        this.openModal(['GeneralModal', {
          title: 'Välj antal',
          content: '<p>Du måste välj hur många du vill ha.</p>',
        }]);
      }
    },
    toggleArticle(addon) {
      if (addon.auto === 'T') {
        return false;
      }

      addon.added = !addon.added; // eslint-disable-line no-param-reassign

      if (!addon.qtySelected) {
        addon.qtySelected = 1; // eslint-disable-line no-param-reassign
      }

      if (addon.added) {
        this.chooseArticle(addon);
      } else {
        this.removeArticle(addon);
      }

      return true;
    },
    removeArticle(addon) {
      addon.added = false; // eslint-disable-line no-param-reassign
      addon.belongsTo = this.accomodationIndex; // eslint-disable-line no-param-reassign

      if (this.isAddonBooking) {
        addon.belongsTo = -2; // eslint-disable-line no-param-reassign
      }

      this.removeAddon(addon);
    },
    infoPopup(addon) {
      this.openModal(['AddonInfoModal', {
        addon,
      }]);
    },
    next() {
      const $this = this;
      if (this.validated()) {
        if (!this.cancellationInsurance && !this.isAddonBooking) {
          this.openModal(['GeneralModal', {
            title: 'Avbeställningsskydd',
            content: '<p>Du har tackat <b>nej</b> till av- och ombokningsförsäkring.</p><p><b>Du har då inte möjlighet att:</b> <p>Byta boende boka om till annan period eller avboka och få pengarna tillbaka enligt gällande bokningsvillkor.</p>',
            buttons: [
              {
                title: 'Jag vill ändra',
                class: 'small white border',
                click: () => {
                  $this.closeModal();
                },
              },
              {
                title: 'Jag förstår',
                class: 'small',
                click: () => {
                  $this.closeModal();
                  $this.$router.push({ name: 'shopping cart', query: { 'show-confirmation': 1, ref: 'accomodation' } });
                },
              },
            ],
          }]);
        } else {
          this.$router.push({ name: 'shopping cart', query: { 'show-confirmation': 1, ref: 'accomodation' } });
        }
      } else {
        let title = '';
        let content = '';
        if (this.cancellationInsurance !== true && this.cancellationInsurance !== false) {
          title = 'Vill du ha Avbeställningskydd?';
          content = '<p>Du behöver ta ställning till om du vill ha avbeställningsskydd eller inte.</p>';
          $this.markInsurance = true;
        } else if (this.lateArrival !== true && this.lateArrival !== false) {
          title = 'Kommer du sent?';
          content = '<p>Du behöver svara på om du kommer sent till anläggningen eller inte.</p>';
          $this.markLate = true;
        }
        this.openModal(['GeneralModal', {
          title,
          content,
          buttons: [
            {
              title: 'Okej, låt mig välja',
              class: 'small',
              click: () => {
                $this.closeModal();
              },
            },
          ],
        }]);
      }
    },
    openLateCheckinInfo() {
      const $this = this;
      this.openModal(['GeneralModal', {
        title: 'Sen incheckning',
        content: `<p>Om du vet att du kommer checka in efter ${this.lateArrivalTime} så kryssa i Ja`,
        buttons: [
          {
            title: 'Okej',
            class: 'small',
            click: () => {
              $this.closeModal();
            },
          },
        ],
      }]);
    },
    adultPrice() {
      const price = this.cartSkipassObject.adults * this.adultPricelistPrice;

      if (price) {
        return price;
      }

      return 0;
    },
    youthPrice() {
      const price = this.cartSkipassObject.youths * this.youthPricelistPrice;

      if (price) {
        return price;
      }

      return 0;
    },
    totalPrice() {
      return this.adultPrice() + this.youthPrice();
    },
    noOfSkipasses() {
      const skipasses = parseInt(this.cartSkipassObject.adults, 10) +
        parseInt(this.cartSkipassObject.youths, 10) +
        parseInt(this.cartSkipassObject.children, 10);

      if (skipasses) {
        return skipasses;
      }

      return 0;
    },
    noOfDays() {
      if (this.cartAccomodationObject && this.cartAccomodationObject.period) {
        const a = moment(this.cartAccomodationObject.period.date_arrival);
        const b = moment(this.cartAccomodationObject.period.date_departure);
        return b.diff(a, 'days') + 1;
      }

      return 0;
    },
    cartSkipasses() {
      this.confirmSkipasses();
    },
    removeSkipasses() {
      this.unconfirmSkipasses();
    },
    modalSkipasses() {
      this.showingSkipassModal = true;
    },
    addSkipassToCart(age, days, number) {
      this.addSkipasses({ age, days, number });
    },
    toggleLate(v) {
      const obj = this.lateArrivalObject;
      obj.title = 'Sen ankomst';
      obj.qtySelected = 1;

      obj.belongsTo = this.accomodationIndex;

      if (this.isAddonBooking) {
        obj.belongsTo = -2;
      }

      if (v.value) {
        this.addAddon(obj);
      } else {
        this.removeAddon(obj);
      }
    },
    validatedSkipasses() {
      return this.noOfSkipasses();
    },
    unmarkInsuranceError() {
      this.markInsurance = false;

      const obj = this.cancellationInsuranceObject;
      obj.title = 'Avbeställningskydd';
      obj.qtySelected = 1;

      obj.belongsTo = this.accomodationIndex;

      if (this.cancellationInsurance) {
        this.addAddon(obj, this.accomodationIndex);
      } else {
        this.removeAddon(obj);
      }
    },
    unmarkLateError() {
      this.markLate = false;
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'
p
  font-size: 14px

.non-clickable
  disabled-normal()

.disabled
  disabled()

.outline-button
  border-radius 4px
  background-color #ffffff
  border solid 1px light-blue-grey
  font-family Interstate
  font-size 11px
  font-weight bold
  color deep-sea-blue
  text-transform uppercase
  text-decoration none
  padding 5px 8px
  display inline-block

h1
  text-align center
  text-transform none
  font-size 30px
  font-weight 900
  text-align center
  color #1c1c1c
  margin-bottom 3px
h2
  font-family  "UnitedSerifCond Heavy"
  font-size 21px
  font-weight 900
  color #1c1c1c
ul
  margin-top 10px
  margin-bottom 10px
  padding-left: 20px
  li
    list-style disc
    margin-bottom 10px
    font-size 14px
    font-weight 300
    list-style-image url(https://static.booking.branasgruppen.se/static/svg/punklista-check.svg)
.ingress
  font-size 18px
  font-weight 300
  text-align center
  color #262626
.skipass-holder
  max-width:890px
  margin 0 auto
  border-radius 2px
  background-color #ffffff
  box-shadow 0 0 8px 0 rgba(0, 0, 0, 0.14)
  .padded
    padding 25px
    width calc(50% - (125px))
    float left

input
  width 2.1em !important
  padding 3px 5px
  border-radius 3px
  background-color #ffffff
  border solid 1px light-blue-grey
  text-align center
  &[readonly]
    border-color transparent
    background-color transparent

.image
  padding-top 295px
  width 250px
  float left
  background-color #fff
  background-image url('https://static.booking.branasgruppen.se/static/img/liftkort.png')
  background-size 80%
  background-repeat no-repeat
  background-position center

.padded
  .space
    margin-top space-2

.skipass-table
  border-left solid 1px light-blue-grey
  border-right solid 1px light-blue-grey
  border-radius 4px 4px 0px 0px
  border-radius 4px
  display table-cell
  th
    border-radius 4px 4px 0px 0px
    background-color rgba(0, 85, 128, 0.85)
    padding 6px 10px
    color white
    font-size 12px
    font-weight bold
    position relative
    top -2px
    span
      font-size 11px
      font-weight 300
  td
    font-family Interstate
    font-size 13px
    font-weight 300
    color #262626
    padding 4px 10px
    border-radius 2px
    background-color rgba(236, 245, 248, 0.3)
    border-bottom solid 1px light-blue-grey
    span
      font-size 8px
  td:nth-child(1)
    width 3em
  td:nth-child(2)
    width 100%
    padding 0 10px
  td:nth-child(3)
    width 150px
  .summarizer
    span
      font-size 11px
      color #9e9e9e
    b
      font-size 16px
      font-weight bold
  .offsetter
    margin-left -25px

.addons
  max-width:890px
  margin 0 auto
  margin-top space-3
  margin-bottom space-3
  padding-bottom 0
  padding-top space-3
  h2
    margin-bottom space-2
  .list
    display flex
    flex-wrap wrap
    justify-content center
    .addon
      border-radius 2px
      background-color #ffffff
      box-shadow 0 0 8px 0 rgba(0, 0, 0, 0.14)
      width 40%
      margin-left: 1.6%
      margin-right: 1.6%
      margin-bottom 3%
      padding 5px
      border: solid 3px white;
      display flex
      cursor pointer
      transition all 0.2s
      &.auto
        cursor: default;
      +max-mobile()
        width 50%
      +max-xs-mobile()
        width: 100%
      &:hover
        box-shadow 0 0 8px 0 rgba(0, 0, 0, 0.38)
        &.auto
          box-shadow: 0
      & > *
        width 50%
      &.selected
        border-color #c7dcb7
      .addon-image
        //height 50px
        border-radius 2px
        background-color rgba(225, 239, 243, 0.3)
        // background-image url('https://static.booking.branasgruppen.se/static/img/helmet.png')
        background-size 28%
        background-repeat no-repeat
        background-position center
        position relative
        margin-right 10px
        .icon
          position absolute
          bottom 5px
          left 5px
          cursor: pointer;
      .addon-content
        text-align: left
        padding-left 5px
        b
          uppercase()
          font-size 11px
          line-height: 1.2em
          font-weight bold
          margin-top 8px
          margin-bottom: 5px
          display block
      /*button,
      .dropdown-wrapper
        float left
        margin-left 5px*/

  &.grocery-bags
    background-color: white
    max-width:100%
    margin 0 0
    margin-top 0
    margin-bottom 0
    padding-bottom 0
    padding-top space-3
    h2
      font-size: 16px;
    .list
      max-width:1000px
      margin 0 auto
      margin-top space-3
      margin-bottom space-3
      padding-bottom 0
      padding-top space-1
      .addon
        display: block
        width 200px
        text-align: center
        padding: 0
        box-shadow: none
        margin-bottom 40px
        +max-screen(925px)
          width 280px
        +max-screen(600px)
          width 200px
        +max-screen(440px)
          width 140px
        .addon-content
          width 100%
          text-align: center;
        .addon-image
          width: 150px;
          height: 155px;
          background-size contain
          background-color: white
          display: inline-block;
          +max-screen(440px)
            width: 100px;
            height: 105px;
        h2
          font-size: 17px;
          letter-spacing: 0.6px;
          text-transform: uppercase;
          display: inline-block;
          margin-top 14px
          margin-bottom: 0

.cancellation-insurance
  border-radius 2px
  background-color rgba(236, 245, 248, 0.5)
  border solid 1px light-blue-grey
  padding 18px 200px
  max-width:890px
  margin 0 auto
  margin-top 20px
  position relative
  +max-tablet()
    padding-left 10px
    padding-right 10px
    width: 96%
  .required-notice
    position absolute
    top 15px
    right 15px
    font-size: 12px;
    font-weight: 300;
    color: #1c1c1c;
    +max-mobile()
      position: relative;
      top 0px
      right 0px
    span
      font-size: 14px;
      color: #ae1116;
      vertical-alignt super
  h3
    font-family Interstate
    font-size 17px
    font-weight bold
    color #262626
    +max-mobile()
      font-size: 15px
    em
      font-style normal
      font-size 26px
      font-weight bold
      letter-spacing 0.3px
      color #262626
      +max-mobile()
        font-size: 23px
        margin-left: 10px
  p
    font-size 13px
    font-weight 300
    line-height 1.38
    color #1c1c1c
    margin-bottom 1.3em

.checkbox-wrapper
  float left
  margin-right 20px
  text-align center

.spacing
  margin-top space-3
  margin-bottom space-3

.SwitchButton
  border 0
  padding 0
  background-color transparent
  display inline-block

select
  border-radius 4px
  background-color pale-grey
  border solid 1px light-blue-grey
  font-size 11px
  font-weight bold
  letter-spacing 0.3px
  color deep-sea-blue
  text-transform uppercase
  padding 6px
  margin: 0px 8px

.input-wrapper
  b
    uppercase()
    font-size: 11px
  input
    margin-bottom: 6px

.quantity
  display: inline-block;
  margin-right 10px

.float-left
  float left
  margin-right 2px
  margin-left 3px
.float-right
  float right
  margin-left 2px
  margin-right 3px

.bg-color-faded
  background-color #fbfbf8

.late-arrival
  border-radius 2px
  padding 10px 18px
  background-color #ffffff
  box-shadow 0 0 8px 0 rgba(0, 0, 0, 0.14)
  display: inline-block
  width:350px
  +max-mobile()
    width 96%
  position:relative
  .inner
    display flex
    text-align: left
    p
      &:first-child
        padding-right 35px
      margin-bottom 0
      &.checkboxes
        padding-top 5px
      b
        display block
        position: relative
        uppercase()
        margin-bottom 5px

.radio-wrapper
  margin-right: 15px;

.with-rut
  font-size: 80%
</style>



// WEBPACK FOOTER //
// AddonsPage.vue?1a6920f7